import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import type StaticMapSize from '@alltrails/types/StaticMapSize';
import { X_AT_KEY } from './api';
import getPhotoSizeServerFromDimensions from './getPhotoSizeServerFromDimensions';

type Args = {
  baseUrl: string;
  id: string | number;
  size: PhotoSizeDimensions;
  staticMapScale: number;
  staticMapSize: StaticMapSize;
};

const getTrailProfilePhotoUrl = ({ baseUrl, id, size, staticMapScale, staticMapSize }: Args) => {
  const params = new URLSearchParams();
  params.set('key', X_AT_KEY);
  params.set('show_static_map', 'true');
  params.set('size', getPhotoSizeServerFromDimensions(size));
  params.set('static_map_scale', String(staticMapScale));
  params.set('static_map_size', staticMapSize);

  return `${baseUrl}/api/alltrails/v3/trails/${id}/profile_photo?${params.toString()}`;
};

export default getTrailProfilePhotoUrl;
